import { useParams, useLocation } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";
import Toast from "../../../core/components/core/Util/Toast/Toast";

function Form() {
    const location = useLocation();
    const isPreSale = location.pathname.includes('/pre-sales/');

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {
        type: isPreSale ? 'pre-sale' : 'sale'
    }

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    if (profileFilter.gci_real_state_id) {
        hiddenValues.gci_real_state_id = profileFilter.gci_real_state_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/sales/save`,
        endpointGetAllCities: `${endpointBackend}gci/cities/getall`,
        endpointGetAllRealState: `${endpointBackend}gci/real-state/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpointGetAllVentures: `${endpointBackend}gci/ventures/getall`,
        endpointGetAllUnits: `${endpointBackend}gci/units/getall`,
        endpointGetUnitById: `${endpointBackend}gci/units/getById`,
        endpointGetAllSellers: `${endpointBackend}gci/sellers/getall`,
        endpointGetAllBusinessTypes: `${endpointBackend}gci/business-types/getall`,
        endpointGetAllClients: `${endpointBackend}gci/clients/getall`,
        endpointGetAllPaymentMethods: `${endpointBackend}gci/payment-methods/getall`,
        endpointGetAllAccountingPlans: `${endpointBackend}gci/accounting-plans/getall`,
        endpointGetBankAccountByProjectId: `${endpointBackend}gci/bank-accounts/getBankAccountByProjectId`,
        endpointGetById: `${endpointBackend}gci/sales/getById`,
        urlGoBack: isPreSale ? `/gci/pre-sales/list` : `/gci/sales/list`,
        pathView: isPreSale ? `/gci/pre-sales/view` : `/gci/sales/view`
    }

    const labels = {
        labelTitleAdd: isPreSale ? "Nova Pré-Venda" : "Nova Venda",
        labelTitleEdit: isPreSale ? "Editar Pré-Venda" : "Editar Venda",
        labelTitleView: isPreSale ? 'Visualizar Pré-Venda' : 'Visualizar Venda'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            showSubmitButton: values.type != 'pre-sale-reproved',
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    readOnly: !!id,
                    handleChange: async (element, field, values) => {
                        values.gci_project_id = null;
                        values.gci_unit_id = null;
                        values.gci_real_state_id = null;
                        values.gci_seller_id = null;
                        values.clients = null;
                        values.payment_methods = [];

                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: true,
                        hasBankAccount: true
                    },
                    readOnly: !!id,
                    handleChange: async (element, field, values) => {
                        values.gci_unit_id = null;

                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                },
                {
                    name: 'gci_unit_id',
                    type: 'select',
                    label: 'Unidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllUnits,
                        label: 'unit',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                gci_project_id: values.gci_project_id,
                                status: 'available',
                                gci_unit_id: values.gci_unit_id ?? null
                            }
                        }
                    },
                    validations: {
                        required: true,
                    },
                    readOnly: !!id,
                    handleChange: async (element, field, values) => {
                        const unit = await Fetch.post(paths.endpointGetUnitById, { id: element.target.value });

                        let message = ''
                        if (unit.status != 'available') {
                            message += `A unidade ${unit.unit} está ${unit.formattedStatus}`
                            if (unit.status == 'reserved') {
                                message += ` até o dia ${unit.formatted_reservation_limit}`
                            }
                            Toast.warning(message)
                        }
                    },
                    columnSize: !profileFilter.gci_real_state_id ? 6 : 12
                },
                !profileFilter.gci_real_state_id ? {
                    name: 'gci_real_state_id',
                    type: 'select',
                    label: 'Imobiliária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllRealState,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_seller_id = null;

                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 6
                } : {},
                {
                    name: 'gci_seller_id',
                    type: 'select',
                    label: 'Corretor',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSellers,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                gci_real_state_id: values.gci_real_state_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'gci_business_type_id',
                    type: 'select',
                    label: 'Tipo de Negócio',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBusinessTypes,
                        label: 'business_type',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'value',
                    type: 'decimal',
                    label: 'Valor da Venda',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'clients',
                    type: 'multiinput',
                    label: 'Cliente (s)',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'gci_client_id',
                            type: 'select',
                            label: 'Cliente',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllClients,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        ...profileFilter,
                                        gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'main_client',
                            type: 'select',
                            label: 'Principal',
                            options: [
                                { label: 'Não', value: 'N' },
                                { label: 'Sim', value: 'S' }
                            ],
                            validations: {
                                required: false
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_condition',
                    type: 'textarea',
                    label: 'Condição de Pagamento',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'payment_methods',
                    type: 'multiinput',
                    label: 'Formas de Pagamento',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'gci_accounting_plan_id',
                            type: 'select',
                            label: 'Plano de Contas',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllAccountingPlans,
                                label: 'name',
                                value: 'id',
                                filter: {
                                    ...profileFilter,
                                    gci_company_id: values.gci_company_id || profileFilter.gci_company_id || null,
                                    onlyLastLevel: true
                                }
                            },
                            validations: {
                                required: true
                            },
                            styleTh: { width: '20%' }
                        },
                        {
                            name: 'gci_payment_method_id',
                            type: 'select',
                            label: 'Forma de Pagamento',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllPaymentMethods,
                                label: 'name',
                                value: 'id',
                                params: {
                                    filter: {
                                        type: ['revenue', 'both']
                                    }
                                }
                            },
                            validations: {
                                required: true
                            },
                            styleTh: { width: '20%' }
                        },
                        {
                            name: 'number_of_installments',
                            type: 'integer',
                            label: 'Parcelas',
                            validations: {
                                required: true
                            },
                            styleTh: { width: '9%' }
                        },
                        {
                            name: 'amount',
                            type: 'decimal',
                            label: 'Valor Parcela',
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'periodicity',
                            type: 'integer',
                            label: 'Periodicidade (dias)',
                            validations: {
                                required: false
                            },
                            styleTh: { width: '12%' }
                        },
                        {
                            name: 'initial_date',
                            type: 'date',
                            label: 'Data Inicial de Cobrança',
                            validations: {
                                required: true
                            },
                            styleTh: { width: '15%' }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    label: 'Arquivo',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'observation',
                    type: 'textarea',
                    label: 'Observações',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                hasBankAccount: async (value, options, key, attributes) => {

                    try {
                        const bankAccount = await Fetch.post(paths.endpointGetBankAccountByProjectId, {
                            filter: {
                                gci_project_id: value
                            }
                        });

                        if (Object.keys(bankAccount).length === 0) {
                            return '^Não existe uma conta bancária cadastrada para este projeto.';
                        }

                        return '';
                    } catch (e) {
                        console.log(e);
                        return '^Erro ao verificar conta bancária.';
                    }
                }
            },
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            values.document_type = values.document_type || 'CPF';

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
